import LabelProvider from "core/components/label/LabelProvider";
import { Messages } from "common/Labels/Messages";
import { filters } from "common/Labels/Refine";

export default LabelProvider.create({

	FirstName: {
		k: "user.firstName",
		v: "First Name"
	},

	LastName: {
		k: "user.lastName",
		v: "Last Name"
	},

	Email: {
		k: "user.email",
		v: "Email"
	},

	LastLogin: {
		k: "user.lastLoginDate",
		v: "Last Login"
	},
	...Messages,
	...filters,
    OrganizationEmpty:{
        k: "organization.missing.title",
        v: "No Organization Selected"
    },
    DescriptionEmpty:{
        k: "organization.missing.description",
        v: "Please select an organization to see the user list."
    }
});



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/UserList.labels.ts